import { Component } from '@angular/core'
import { MenuItem } from 'primeng/api'

import { AuthService } from '@data/services/modules/auth/auth.service'
import { MENU_AUTHORIZATION } from './constants/menu.constant'
import { UserRole } from '@data/enums/user-role.enum'

@Component({
  selector: 'app-skeleton-leftnav',
  templateUrl: './skeleton-leftnav.component.html',
  styleUrls: ['./skeleton-leftnav.component.scss'],
})
export class SkeletonLeftnavComponent {
  items: MenuItem[] = []
  itemsAuthorization = MENU_AUTHORIZATION
  constructor(private authService: AuthService) {}
  ngOnInit() {
    for (const item of this.itemsAuthorization) {
      const mainModule: {
        label: string
        expanded: boolean
        items: {
          label: string
          icon: string
          routerLink: string
        }[]
      } = {
        label: item.title,
        expanded: true,
        items: [],
      }
      const currentRoleName = this.authService.getUser?.user?.permissions?.name as UserRole | undefined
      for (const module of item.modules) {
        // Gating principal: permiso del módulo. Adicional: si el item declara `roles`,
        // el rol actual debe estar en la lista (ej. "Administradores" solo para Admin
        // aunque Legal también tenga `users.view`).
        const hasPermission = this.authService.hasModulePermission(module.module, module.permission)
        const matchesRole = !module.roles || (currentRoleName != null && module.roles.includes(currentRoleName))
        if (hasPermission && matchesRole) {
          mainModule.items.push({
            label: module.label,
            icon: module.icon,
            routerLink: module.routerLink,
          })
        }
      }
      if (mainModule.items.length > 0) this.items.push(mainModule)
    }
  }
}
